import React from 'react'
import PropTypes from 'prop-types'
import uniqueId from 'lodash/uniqueId'
import Svg from '../../Svg'

const genId = () => uniqueId('interestTeaser')
const a = genId()
const b = genId()
const c = genId()
const d = genId()
const e = genId()
const f = genId()

const propTypes = {
  className: PropTypes.string,
}

const InterestTeaserScreen = props => (
  <Svg viewBox='0 0 486 405' {...props}>
    <defs>
      <path id={b} d='M1 0h450v369H1z' />
      <filter
        id={a}
        width='112.4%'
        height='115.2%'
        x='-6.2%'
        y='-7%'
        filterUnits='objectBoundingBox'
      >
        <feOffset dy='2' in='SourceAlpha' result='shadowOffsetOuter1' />
        <feGaussianBlur
          in='shadowOffsetOuter1'
          result='shadowBlurOuter1'
          stdDeviation='9'
        />
        <feColorMatrix
          in='shadowBlurOuter1'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.55 0'
        />
      </filter>
      <filter
        id={c}
        width='109.8%'
        height='128.6%'
        x='-4.9%'
        y='-10.2%'
        filterUnits='objectBoundingBox'
      >
        <feOffset dy='2' in='SourceAlpha' result='shadowOffsetOuter1' />
        <feGaussianBlur
          in='shadowOffsetOuter1'
          result='shadowBlurOuter1'
          stdDeviation='2'
        />
        <feColorMatrix
          in='shadowBlurOuter1'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
        />
      </filter>
      <text
        id={d}
        fill='var(--brand-danger-600)'
        fontFamily='OpenSans-Light, Open Sans'
        fontSize='36'
        fontWeight='300'
      >
        <tspan x='.194' y='67'>
          -$21,904
        </tspan>
      </text>
      <text
        id={f}
        fill='var(--brand-success-700)'
        fontFamily='OpenSans-Light, Open Sans'
        fontSize='36'
        fontWeight='300'
      >
        <tspan x='6.486' y='67'>
          $76,853
        </tspan>
      </text>
      <filter
        id={e}
        width='110.6%'
        height='128.6%'
        x='-5.3%'
        y='-10.2%'
        filterUnits='objectBoundingBox'
      >
        <feOffset dy='2' in='SourceAlpha' result='shadowOffsetOuter1' />
        <feGaussianBlur
          in='shadowOffsetOuter1'
          result='shadowBlurOuter1'
          stdDeviation='2'
        />
        <feColorMatrix
          in='shadowBlurOuter1'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
        />
      </filter>
    </defs>
    <g fill='none' fillRule='evenodd'>
      <g transform='translate(17 16)'>
        <use
          fill='var(--brand-hb-black)'
          filter={`url(#${a})`}
          href={`#${b}`}
        />
        <use fill='var(--brand-surface-elevation-300)' href={`#${b}`} />
      </g>
      <path
        fill='var(--brand-success-700)'
        fillRule='nonzero'
        d='M275.5 277a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15zm-1.008 10.119a.526.526 0 0 0 .364-.186l3.146-3.749a.52.52 0 0 0-.063-.742.532.532 0 0 0-.742.067l-2.764 3.294-1.196-1.426a.526.526 0 0 0-.804.675l1.585 1.89c.12.143.301.204.474.177zM275.5 278a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13z'
      />
      <text
        fill='var(--brand-neutral-cool-900)'
        fontFamily='OpenSans-Light, Open Sans'
        fontSize='18'
        fontWeight='300'
        transform='translate(267 141)'
      >
        <tspan x='42.375' y='19'>
          30 Year
        </tspan>
      </text>
      <g transform='translate(267 141)'>
        <use filter={`url(#${c})`} href={`#${d}`} />
        <use href={`#${d}`} />
      </g>
      <text
        fill='var(--brand-neutral-cool-700)'
        fontFamily='OpenSans-Regular, Open Sans'
        fontSize='14'
        transform='translate(267 141)'
      >
        <tspan x='23' y='106'>
          Long term loss
        </tspan>
      </text>
      <path
        fill='var(--brand-danger-600)'
        fillRule='nonzero'
        d='M275.5 250a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13zm-.023-7.334l-1.685-1.685a.484.484 0 0 0-.677-.002.484.484 0 0 0 .002.677l1.685 1.685-1.685 1.686a.484.484 0 0 0-.002.677c.186.187.494.18.677-.002l1.685-1.685 1.686 1.685a.484.484 0 0 0 .677.002.484.484 0 0 0-.002-.677l-1.686-1.686 1.686-1.685a.484.484 0 0 0 .002-.677.484.484 0 0 0-.677.002l-1.686 1.685zM275.5 251a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15z'
      />
      <text
        fill='var(--brand-neutral-cool-700)'
        fontFamily='OpenSans-Regular, Open Sans'
        fontSize='14'
        transform='translate(267 141)'
      >
        <tspan x='23' y='147'>
          Payment goes down{' '}
        </tspan>{' '}
        <tspan x='23' y='168'>
          by $56/month
        </tspan>
      </text>
      <g>
        <path
          fill='var(--brand-danger-600)'
          fillRule='nonzero'
          d='M83.5 291a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13zm-.023-7.334l-1.685-1.685a.484.484 0 0 0-.677-.002.484.484 0 0 0 .002.677l1.685 1.685-1.685 1.686a.484.484 0 0 0-.002.677c.186.187.494.18.677-.002l1.685-1.685 1.686 1.685a.484.484 0 0 0 .677.002.484.484 0 0 0-.002-.677l-1.686-1.686 1.686-1.685a.484.484 0 0 0 .002-.677.484.484 0 0 0-.677.002l-1.686 1.685zM83.5 292a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15z'
        />
        <text
          fill='var(--brand-neutral-cool-700)'
          fontFamily='OpenSans-Regular, Open Sans'
          fontSize='14'
          transform='translate(76 141)'
        >
          <tspan x='22' y='147'>
            Payment goes up{' '}
          </tspan>{' '}
          <tspan x='22' y='168'>
            by $467/month
          </tspan>
        </text>
        <text
          fill='var(--brand-neutral-cool-700)'
          fontFamily='OpenSans-Regular, Open Sans'
          fontSize='14'
          transform='translate(76 141)'
        >
          <tspan x='22' y='106'>
            Long term savings
          </tspan>
        </text>
        <path
          fill='var(--brand-success-700)'
          fillRule='nonzero'
          d='M84.5 236a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15zm-1.008 10.119a.526.526 0 0 0 .364-.186l3.146-3.749a.52.52 0 0 0-.063-.742.532.532 0 0 0-.742.067l-2.764 3.294-1.196-1.426a.526.526 0 0 0-.804.675l1.585 1.89c.12.143.301.204.474.177zM84.5 237a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13z'
        />
        <g fill='var(--brand-success-700)' transform='translate(76 141)'>
          <use filter={`url(#${e})`} href={`#${f}`} />
          <use href={`#${f}`} />
        </g>
        <text
          fill='var(--brand-neutral-cool-900)'
          fontFamily='OpenSans-Light, Open Sans'
          fontSize='18'
          fontWeight='300'
          transform='translate(76 141)'
        >
          <tspan x='40.375' y='19'>
            15 Year
          </tspan>
        </text>
      </g>
      <text
        fill='var(--brand-neutral-cool-900)'
        fontFamily='OpenSans-Light, Open Sans'
        fontSize='22'
        fontWeight='300'
        transform='translate(17 83)'
      >
        <tspan x='39.553' y='24'>
          What could a refi save you in interest?
        </tspan>
      </text>
    </g>
  </Svg>
)

InterestTeaserScreen.propTypes = propTypes

export default InterestTeaserScreen
